import { render, staticRenderFns } from "./MultiDepartmentListSelector.vue?vue&type=template&id=68f15414&scoped=true&"
import script from "./MultiDepartmentListSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiDepartmentListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiDepartmentListSelector.vue?vue&type=style&index=0&id=68f15414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f15414",
  null
  
)

export default component.exports